<template>
    <div>
		<div class="surveyName">{{name}}</div>
		<div class="page-btns-box" v-if="$utils.have('/survey/createOrUpdate')" >
		    <el-button type="primary"  size="small" @click="$refs.DataTable.show()">汇总统计</el-button>			
			<el-button type="primary" icon="el-icon-download" size="small" @click="download()">导出明细</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="newData.rows"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >                
				<template v-for="(col,index) in newData.cols">
					<el-table-column :label="col.label">
						<template slot-scope="scope">
							<span v-if="scope.row[index].type!=2">{{scope.row[index].content}}</span>
							<!-- <el-image v-else style="width: 100px; height: 100px" :src="scope.row[index].content" ></el-image> -->							
							<span v-else  v-for="item in scope.row[index].content" class="imgClass">
								<el-image
									 :src="item | coverImage(50,50)" fit="cover" 
									:preview-src-list="[item]">
								</el-image>
							</span>
							<!-- <el-image 
								v-else :src="scope.row[index].content | coverImage(50,50)" fit="cover" 
								:preview-src-list="[scope.row[index].content]"
								:length="scope.row[index].content"></el-image> -->
						</template>
					</el-table-column>
				</template>
            </el-table>
        </div>
		<div v-if="data.data" class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="getDataList"
		        :current-page.sync="params.pageNo"
		        :page-sizes="$pageSizes"
		        :page-size.sync="params.pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="data.total || 0">
		    </el-pagination>
			
		</div>		
		<data-table ref="DataTable" :id="id" :name="name"></data-table>
    </div>
</template>

<script>
import DataTable from "./components/DataTable";
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultQuery = {
    pageNo: 1,
    pageSize: 15,
    
};
export default {
	props:{
	    id: {
	        type: [Number, String],
	        default: () => null
	    },
		name :{
			type: [Number, String],
			default: () => null
		}
	},
    components:{DataTable},
    data(){
        return{
            data:{},           
            params: {...defaultQuery},
            listLoading: false,
			
			newData:{}
			
        }
    },
    mounted() {
        this.getDataList();
    },
	computed:{
	   
	},
    methods: {
        //获取列表		
        getDataList() {			
            this.listLoading = true;
            this.$request({
                url: "/survey/statistics",
                method: "POST",
                data: {
                    ...this.params,
					id:this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					var tableData = {"cols":[],"rows":[],"types":[]};
					this.data.title.forEach((title , index)=>{
						tableData.cols[index] = {"label":title}
					})
					
					this.data.data.forEach( ( item , index ) => {						
						item.forEach( ( item2 , index2 ) => {
							if( item2.type == 2 ){
								item2.content = item2.content.split(',')								
							}
							tableData.rows[index] = item
						})
					})
					
					this.newData = tableData
					
					
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
		download(){
			var now = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd HH:mm:ss' );			
		   let filePath;
		   this.downLoading = true;
			this.$request({
				url: '/survey/export',
				method: 'POST',
				data: {
					 ...this.params,
					 id: this.id                   
				 },
			}).then(res => {
				const { state, msg, result } = res.data;
				if( state == 1 && result ){
					filePath = result.url;					
					downloadFileTmp(filePath,`${now}_${this.id}_问卷数据统计.`+this.$utils.getFileType(filePath));
					this.downLoading = false;
				}else{
					this.downLoading = false;
					return this.$message.error(msg || '下载失败');
				}
			}).catch(() => {
				this.$message.error('请求错误');
			}).finally(() => {
				this.listLoading = false;
			});					
		},
		//选择pageSize
		handleSizeChange(e) {
		    this.params.pageNo = 1;
		    this.params.pageSize = e;
		    this.getDataList();
		},
		
    }
}
</script>

<style lang="scss" scoped>
.green{
	color: #1FBB7D;
}
.MR10{
	margin-right: 10px;
	display: inline-block;
	vertical-align: middle;
}
.el-card{
    .el-col{
        line-height: 28px;
    }
}
.surveyName{
	background:#f4f4f5;
	height:30px;
	line-height:30px;
	margin-bottom:20px;
	padding-left:20px
}
.imgClass{
	margin-right: 20px;
}
</style>